import React from 'react'
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'
import { Button } from '@mui/material'
import excel_img from '../asset/excel_img.png'
import secureLocalStorage from 'react-secure-storage'
import Api from '../Api/Api'
import dayjs from 'dayjs'

const ExcelExport = ({ data, fileName, excelObject }) => {
  console.log('엑셀테스트 data1:', data)

  // function convertToString(origin, target) {
  //   if (origin.id === target) return [origin.label]
  //   if (!origin.children) return false
  //   let path
  //   const test = origin.children.find((x) => (path = convertToString(x, target)))
  //   //  console.log("test:",test)
  //   if (path) {
  //     return [origin.label].concat(path)
  //   }
  // }

  // function findPathInMeneResult(param) {
  //   let path
  //   data.map((item) => {
  //     return [item].find((x) => (path = convertToString(x, param)))
  //   })
  //   return path
  // }

  //엑셀 해더이름 변환
  function headerList(p1, p2) {
    console.log('headerList p1:', p1)
    console.log('headerList p2:', p2)

    if (nullCheck(p1) === false) {
      let tempList = Object.keys(p1)
      let copyList = [...tempList]
      console.log('headerList copyList1:', copyList)

      if (p2) {
        switch (p2) {
          case '안전사고통계조회':
            copyList.map((item, index) => {
              if (item === 'lon') {
                copyList[index] = '발생위치'
              }
              if (item === 'ji_name') {
                copyList[index] = '작업명'
              }
              if (item === 'ji_time') {
                copyList[index] = '작업시간'
              }
              if (item === 'di_name') {
                copyList[index] = '사고 분석 장비'
              }
              if (item === 'udt') {
                copyList[index] = '발생시간'
              }
              if (item === 'data_type') {
                copyList[index] = '사고유형'
              }
              if (item === 'user_name') {
                copyList[index] = '근로자명'
              }
            })
            return [copyList]

          case 'auditlog':
            copyList.map((item, index) => {
              if (item === 'audit') {
                copyList[index] = '계정'
              }
              if (item === 'sys') {
                copyList[index] = '접속시스템'
              }
              if (item === 'fc') {
                copyList[index] = '기능'
              }
              if (item === 'cdt') {
                copyList[index] = '감사발생시간'
              }
              if (item === 'tg') {
                copyList[index] = '감사발생위치(기본파일이름)'
              }
            })
            return [copyList]
          case 'syslog':
            copyList.map((item, index) => {
              if (item === 'udt') {
                copyList[index] = '날짜'
              }
              if (item === 'cd') {
                copyList[index] = '타입코드'
              }
              if (item === 'lv') {
                copyList[index] = '위험도'
              }
              if (item === 'rst') {
                copyList[index] = '결과'
              }
              if (item === 'fc') {
                copyList[index] = '기능'
              }
              if (item === 'di') {
                copyList[index] = '관리자'
              }
              if (item === 'sys') {
                copyList[index] = '시스템'
              }
              if (item === 'description') {
                copyList[index] = '내용'
              }
            })
            return [copyList]
          case 'servicelog':
            copyList.map((item, index) => {
              if (item === 'udt') {
                copyList[index] = '날짜'
              }
              if (item === 'cd') {
                copyList[index] = '타입코드'
              }
              if (item === 'lv') {
                copyList[index] = '위험도'
              }
              if (item === 'rst') {
                copyList[index] = '결과'
              }
              if (item === 'fc') {
                copyList[index] = '기능'
              }
              if (item === 'di') {
                copyList[index] = '데이터전송장비'
              }
              if (item === 'sys') {
                copyList[index] = '시스템'
              }
              if (item === 'description') {
                copyList[index] = '내용'
              }
            })
            return [copyList]
          case 'userslog':
            copyList.map((item, index) => {
              if (item === 'audit') {
                copyList[index] = '계정'
              }
              if (item === 'sys') {
                copyList[index] = '시스템'
              }
              if (item === 'cdt') {
                copyList[index] = '접속시간'
              }
              if (item === 'edt') {
                copyList[index] = '종료시간'
              }
              if (item === 'tm') {
                copyList[index] = '사용시간(시,분,초)'
              }
              if (item === 'tg') {
                copyList[index] = '접속시스템'
              }
              if (item === 'fc') {
                copyList[index] = '기능'
              }
            })
            return [copyList]

          default:
            return [copyList]
        }
      } else {
        copyList.map((item, index) => {
          if (item === 'loid') {
            copyList[index] = '시설ID'
          }
          if (item === 'ji') {
            copyList[index] = '작업ID'
          }
          if (item === 'wid') {
            copyList[index] = '근로자ID'
          }
          if (item === 'di') {
            copyList[index] = '장비ID'
          }
          if (item === 'udt') {
            copyList[index] = '발생시간'
          }
          if (item === 'data_type') {
            copyList[index] = '사고유형'
          }
          if (item === 'lon') {
            copyList[index] = '시설명'
          }
          if (item === 'ji_name') {
            copyList[index] = '작업명'
          }
          if (item === 'ji_time') {
            copyList[index] = '작업시간'
          }
          if (item === 'user_name') {
            copyList[index] = '근로자명'
          }
          if (item === 'di_name') {
            copyList[index] = '장비명'
          }
          if (item === 'deviceLists') {
            copyList[index] = '장비목록'
          }
          if (item === 'edt') {
            copyList[index] = '작업종료시간'
          }
          if (item === 'sdt') {
            copyList[index] = '작업시작시간'
          }
          if (item === 'orgid') {
            copyList[index] = '부서ID'
          }
          if (item === 'user_len') {
            copyList[index] = '투입인원수'
          }
          if (item === 'orglists') {
            copyList[index] = '상세경로'
          }
          if (item === 'orglist') {
            copyList[index] = '상세위치'
          }
          if (item === 'wkl') {
            copyList[index] = '근로자목록'
          }
          if (item === 'jn') {
            copyList[index] = '작업시설이름'
          }
          if (item === 'dvlen') {
            copyList[index] = '설치장비개수'
          }
          if (item === 'fname') {
            copyList[index] = '파일이름'
          }
          if (item === 'uid') {
            copyList[index] = '관리자'
          }
          if (item === 'dsi') {
            copyList[index] = '장비유형'
          }
          if (item === 'dname') {
            copyList[index] = '장비명'
          }
          if (item === 'cnm') {
            copyList[index] = '제조사'
          }
          if (item === 'topic_list') {
            copyList[index] = '기능정보'
          }
          if (item === 'b_service_list') {
            copyList[index] = '블루투스 서비스 리스트'
          }
          if (item === 'ble_rssi') {
            copyList[index] = '블루투스 신호감도'
          }
          if (item === 'create_date') {
            copyList[index] = '등록일자'
          }
          if (item === 'ph') {
            copyList[index] = '전화번호'
          }
          if (item === 'ml') {
            copyList[index] = '이메일'
          }
          if (item === 'puid') {
            copyList[index] = '상위관리자ID'
          }
          if (item === 'cdt') {
            copyList[index] = '생성일자'
          }
          //
        })
        console.log('headerList copyList2:', copyList)
        return [copyList]
      }
    }
  }
  function nullCheck(param) {
    if (param !== undefined && param !== null && param !== '') {
      return false
    } else {
      return true
    }
  }

  function convertObject(param) {
    if (nullCheck(param) === false) {
      const convertObject_temp = JSON.stringify(Object.values(param))
      return convertObject_temp
    }
  }

  const exportToExcel = async () => {
    if (nullCheck(data) === false && data.length > 0) {
      const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
      const loginId = secureLocalStorage.getItem('loginId')

      //copy array of objects and make changes without modifying originam array

      let copyList = data.map((item) => ({ ...item }))

      copyList.map((item) => {
        if (item.hasOwnProperty('wkl')) {
          item['wkl'] = convertObject(item['wkl'])
        }
        if (item.hasOwnProperty('orglists')) {
          item['orglists'] = convertObject(item['orglists'])
        }
        if (item.hasOwnProperty('deviceLists')) {
          item['deviceLists'] = convertObject(item['deviceLists'])
        }
        if (item.hasOwnProperty('orglist')) {
          item['orglist'] = convertObject(item['orglist'])
        }
        if (item.hasOwnProperty('topic_list')) {
          item['topic_list'] = convertObject(item['topic_list'])
        }
        if (item.hasOwnProperty('b_service_list')) {
          item['b_service_list'] = convertObject(item['b_service_list'])
        }
        if (item.hasOwnProperty('dvloc')) {
          delete item['dvloc']
        }
        if (item.hasOwnProperty('detail')) {
          delete item['detail']
        }
        if (item.hasOwnProperty('pw')) {
          delete item['pw']
        }
        if (item.hasOwnProperty('ladt')) {
          delete item['ladt']
        }
        if (item.hasOwnProperty('lgfcnt')) {
          delete item['lgfcnt']
        }
        if (item.hasOwnProperty('lv')) {
          item['lv'] =
            item['lv'] === 1
              ? 'INFO'
              : item['lv'] === 2
                ? 'WARN'
                : item['lv'] === 3
                  ? 'DANGER'
                  : item['lv'] === 4
                    ? 'CRIT'
                    : ''
        }
        if (item.hasOwnProperty('rst')) {
          item['rst'] =
            item['rst'] === 1
              ? '성공'
              : item['rst'] === 2
                ? '실패'
                : item['rst'] === 3
                  ? '시작'
                  : item['rst'] === 4
                    ? '성공(종료)'
                    : item['rst'] === 5
                      ? '실패(종료)'
                      : ''
        }

        if (item.hasOwnProperty('fc') && excelObject && excelObject.type === 'userslog') {
          item['fc'] = item['fc'] === 1000 ? '접속정보' : ''
        }
        if (item.hasOwnProperty('idx')&& excelObject && excelObject.type === 'userslog') {
          delete item['idx']
        }
        if (item.hasOwnProperty('fdesc')&& excelObject && excelObject.type === 'userslog') {
          delete item['fdesc']
        }
        if (item.hasOwnProperty('fc')&& excelObject && excelObject.type === 'auditlog') {
          item['fc'] = item['fc'] === 1000 ? '접속정보' : item['fc'] === 2000 ? '파일다운로드' : ''
        }
        if (item.hasOwnProperty('idx')&& excelObject && excelObject.type === 'auditlog') {
          delete item['idx']
        }
        if (item.hasOwnProperty('fdesc')&& excelObject && excelObject.type === 'auditlog') {
          delete item['fdesc']
        }
        if (item.hasOwnProperty('edt')&& excelObject && excelObject.type === 'auditlog') {
          delete item['edt']
        }
        if (item.hasOwnProperty('tm')&& excelObject && excelObject.type === 'auditlog') {
          delete item['tm']
        }

        if (item.hasOwnProperty('loid')&& excelObject && excelObject.type === '안전사고통계조회') {
          delete item['loid']
        }
        if (item.hasOwnProperty('ji')&& excelObject && excelObject.type === '안전사고통계조회') {
          delete item['ji']
        }
        if (item.hasOwnProperty('wid')&& excelObject && excelObject.type === '안전사고통계조회') {
          delete item['wid']
        }
        if (item.hasOwnProperty('di')&& excelObject && excelObject.type === '안전사고통계조회') {
          delete item['di']
        }
      })
      const typeParam = excelObject !== undefined ? excelObject.type : undefined
      let Heading = headerList(copyList[0], typeParam)
      //Had to create a new workbook and then add the header
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, Heading)
      //Starting in the second row to avoid overriding and skipping headers
      XLSX.utils.sheet_add_json(ws, copyList, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `${fileName}.xlsx`)

      //감사로그
      try {
        const auditObject = {
          cdt: now,
          audit: loginId,
          sys: 'PORTAL',
          fc: '2000',
          tg: fileName,
        }
        const response = await Api.post('/api/v1/audit', auditObject)
        if (response.status === 200) {
          console.log('ExcelExport audit response ok.')
        }
      } catch (e) {
        console.log('ExcelExport catch error:', e)
      }
    }
  }
  return (
    <>
      <Button variant="contained" sx={{ color: '#ffffff', background: '#454546' }} onClick={() => exportToExcel()}>
        <img style={{ width: 25, height: 25 }} src={excel_img}></img>
        &nbsp;엑셀 내보내기
      </Button>
    </>
  )
}

export default ExcelExport
